import { render, staticRenderFns } from "./the-supplier-orders.vue?vue&type=template&id=f76d9b90&scoped=true"
import script from "./the-supplier-orders.vue?vue&type=script&lang=js"
export * from "./the-supplier-orders.vue?vue&type=script&lang=js"
import style0 from "./the-supplier-orders.vue?vue&type=style&index=0&id=f76d9b90&prod&lang=css"
import style1 from "./the-supplier-orders.vue?vue&type=style&index=1&id=f76d9b90&prod&scoped=true&lang=css"
import style2 from "./the-supplier-orders.vue?vue&type=style&index=2&id=f76d9b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76d9b90",
  null
  
)

export default component.exports